import { takeEvery, fork, all } from 'redux-saga/effects';
import { logoutSaga, authSaga } from 'features/auth/authSaga';
import { userSaga } from 'features/user/userSaga';
import { companySaga } from 'features/company/companySaga';
import { companyVehicleSaga } from 'features/vehicles/companyVehicleSaga';
import { companyUsersSaga } from 'features/users/companyUsersSaga';
import { companySessionsSaga } from 'features/parkingsessions/companySessionsSaga';
import { companyInvoicesSaga } from 'features/invoices/companyInvoicesSaga';
import { paymentMethodSaga } from 'features/paymentmethods/paymentMethodSaga';
import { companyTelematicAccountsSaga } from 'features/telematics/companyTelematicAccountsSaga';
import { importVehiclesSaga } from 'features/vehicles/importVehiclesSaga';
import { registrationV2Saga } from 'features/registration-v2/registrationV2Saga';
import { languageSaga } from 'root/language/languageSaga';
import { feedbackSaga } from 'features/support/feedbackSaga';
import { appSaga } from 'root/appSaga';
import { authSlice } from 'features/auth/authSlice';
import { parkdCardsSaga } from 'features/parkdcards/parkdCardsSaga';


export function* root() {
    yield all([
        fork(appSaga),
        fork(authSaga),
        fork(companySaga),
        fork(companyVehicleSaga),
        fork(companyUsersSaga),
        fork(companySessionsSaga),
        fork(companyInvoicesSaga),
        fork(paymentMethodSaga),
        fork(companyTelematicAccountsSaga),
        fork(parkdCardsSaga),
        fork(importVehiclesSaga),
        fork(registrationV2Saga),
        fork(userSaga),
        fork(languageSaga),
        fork(feedbackSaga),

        // todo: test
        takeEvery(authSlice.actions.logout, logoutSaga),
    ]);
}
